<template>
    <div class="stage-activity w-100 h-100 overflow-hidden d-flex flex-column">
        <div class="d-flex align-items-center px-4 py-3 stage-activity-topbar">
            <button type="button" class="icon-btn me-3" @click="go_back"><i class="bi bi-arrow-left"></i></button>
            <div class="flex-fill me-3" style="min-width: 0">
                <div class="stage-activity-name">{{ stage ? stage.name : 'Etapa' }}</div>
                <StageProgress v-if="questions.length > 0" :types="questions.map((q) => q.question.type)"
                    :index="finished ? questions.length - 1 : current_index"
                    :completed="finished || is_content || own_result.answered"
                    :color="own_jersey_color || undefined" :theme="theme" />
            </div>
            <div class="stage-activity-segment me-3" v-if="!finished && current_wrapper && current_wrapper.question.segment">
                <i class="bi bi-signpost-split-fill me-1"></i>{{ utils.get_segment_label(current_wrapper.question.segment) }}
            </div>
            <div class="ms-auto d-flex align-items-center">
                <span class="stage-activity-user me-2" v-if="$store.state.online_user">{{ $store.state.online_user.username }}</span>
                <button type="button" class="btn btn-sm btn-outline-light" title="Cerrar sesión" @click="logout"><i class="bi bi-box-arrow-left"></i></button>
            </div>
        </div>

        <div class="flex-fill overflow-auto p-4">
            <div v-if="loading" class="stage-activity-empty">
                <span class="spinner-border spinner-border-sm me-2"></span>Cargando...
            </div>

            <div v-else-if="questions.length == 0" class="stage-activity-empty">
                Esta etapa todavía no tiene preguntas.
            </div>

            <div v-else-if="finished" class="stage-complete d-flex flex-column align-items-center justify-content-center h-100 text-center">
                <i class="bi bi-flag-fill stage-complete-icon"></i>
                <div class="stage-complete-headline">¡Etapa completada!</div>
                <div class="stage-complete-detail">Has completado todas las actividades de esta etapa.</div>
                <button type="button" class="btn btn-primary mt-4" @click="go_back">Volver a las etapas</button>
            </div>

            <template v-else-if="current_wrapper">
                <div v-if="is_content" class="d-flex justify-content-end mb-3">
                    <button type="button" class="btn btn-primary" @click="next_question">{{ is_last ? 'Finalizar etapa' : 'Continuar' }} <i class="bi bi-arrow-right ms-1"></i></button>
                </div>
                <div v-else-if="own_result.answered" :class="'feedback-banner mb-4 ' + (own_result.correct ? 'feedback-correct' : 'feedback-incorrect')">
                    <i :class="'bi feedback-icon ' + (own_result.correct ? 'bi-check-circle-fill' : 'bi-x-circle-fill')"></i>
                    <div class="feedback-headline">{{ own_result.correct ? '¡Respuesta correcta!' : 'Respuesta incorrecta' }}</div>
                    <div class="feedback-detail" v-if="correct_answer_text">{{ correct_answer_text }}</div>
                    <div class="feedback-points" v-if="own_result.correct">+{{ Math.round(own_result.score) }} <small>puntos</small></div>
                    <button type="button" class="btn btn-primary mt-3" @click="next_question">{{ is_last ? 'Finalizar etapa' : 'Siguiente pregunta' }}</button>
                </div>

                <div id="text-region" v-html="format_title(current_wrapper.question.title)"></div>
                <FeedbackContent v-if="own_result.answered" class="my-4" :value="current_wrapper.question.feedback" />
                <div id="question-body" class="w-100 mt-4" :key="current_wrapper.question.id">
                    <template v-if="current_wrapper.question.type == utils.ACTIVITY_TYPE.QUIZ">
                        <quiz></quiz>
                    </template>
                    <template v-if="current_wrapper.question.type == utils.ACTIVITY_TYPE.QUIZ_MULTIPLE">
                        <quiz-multiple></quiz-multiple>
                    </template>
                    <template v-if="current_wrapper.question.type == utils.ACTIVITY_TYPE.CROSSWORD">
                        <cross-word></cross-word>
                    </template>
                    <template v-if="current_wrapper.question.type == utils.ACTIVITY_TYPE.TRUE_FALSE">
                        <true-false></true-false>
                    </template>
                    <template v-if="current_wrapper.question.type == utils.ACTIVITY_TYPE.RANGE">
                        <range></range>
                    </template>
                    <template v-if="current_wrapper.question.type == utils.ACTIVITY_TYPE.TEXT">
                        <text-activity></text-activity>
                    </template>
                    <template v-if="is_content">
                        <content-activity></content-activity>
                    </template>
                </div>
            </template>
        </div>

        <div class="modal fade p-3" id="previewImageModal" tabindex="-1" aria-labelledby="previewImageModal" aria-hidden="true">
            <div class="modal-dialog modal-fullscreen w-100 h-100">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5 text-black" id="previewImageModal">Imagen</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body bg-dark bg-opacity-25 w-100 h-100 d-flex justify-content-center align-items-center">
                        <div class="w-100 h-100 d-flex justify-content-center align-items-start">
                            <img class="img-fluid" :src="preview_img">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FeedbackContent from '@/components/FeedbackContent.vue';
import utils from '@/../../shared/utils'
import api from '@/api'
import Quiz from '@/components/type/Quiz.vue'
import QuizMultiple from '@/components/type/QuizMultiple.vue'
import TrueFalse from '@/components/type/TrueFalse.vue'
import Range from '@/components/type/Range.vue'
import TextActivity from '@/components/type/Text.vue'
import CrossWord from '@/components/type/CrossWord.vue'
import StageProgress from '@/components/StageProgress.vue'
import ContentActivity from '@/components/type/Content.vue'

export default {
    name: 'StageActivity',
    components: {
        FeedbackContent,
        Quiz,
        QuizMultiple,
        TrueFalse,
        Range,
        TextActivity,
        CrossWord,
        ContentActivity,
        StageProgress,
    },
    data(){
        return {
            utils: utils,
            current_index: 0,
            finished: false,
            preview_img: null,
            stage: null,
            questions: [],
            // {question, choice, timestamp, correct, score} per answered
            // question - recomputed server-side on every load (GET
            // /api/stages/:id/questions), so there's nothing to go stale;
            // updated locally as each new answer comes back (see the
            // last_online_answer watcher below).
            own_answers: [],
            loading: true,
            // The season's visual theme, from the stage endpoint (online
            // players don't get the season list over the websocket).
            theme: null,
        };
    },
    computed: {
        stage_id(){
            return parseInt(this.$route.params.stage_id);
        },
        current_wrapper(){
            return this.questions[this.current_index] || null;
        },
        // Content activities (image/video/PDF/HTML) have no right/wrong -
        // they're completed just by entering (Content.vue), so instead of the
        // feedback banner the player gets a plain "Continuar" straight away.
        is_content(){
            return !!this.current_wrapper && utils.is_content_activity(this.current_wrapper.question.type);
        },
        own_jersey_color(){
            const user = this.$store.state.online_user;
            return (user && user.avatar_style && user.avatar_style.color) || null;
        },
        is_last(){
            return this.current_index >= this.questions.length - 1;
        },
        own_result(){
            if(!this.current_wrapper) return { answered: false, correct: false, score: 0 };
            const entry = this.own_answers.find((a) => a.question == this.current_wrapper.question.id);
            if(!entry) return { answered: false, correct: false, score: 0 };
            return { answered: true, correct: !!entry.correct, score: entry.score || 0 };
        },
        correct_answer_text(){
            if(!this.current_wrapper) return null;
            var q = this.current_wrapper.question;
            var correctAnswer = q.correctAnswer || [];
            if(q.type == utils.ACTIVITY_TYPE.TEXT || q.type == utils.ACTIVITY_TYPE.RANGE)
                return correctAnswer[0] || null;
            if(q.choices && correctAnswer.length > 0)
                return correctAnswer.map((idx) => q.choices[idx]).join(', ');
            return null;
        }
    },
    watch:{
        current_wrapper(){
            this.sync_question();
        },
        // network.js's send_reliable() intercepts UPDATE_ACTIVITY in online
        // mode and, once POST /api/answers resolves, commits the result
        // here instead of waiting for a websocket broadcast that will never
        // come. Merge it into own_answers so the feedback banner reacts
        // immediately, without a refetch.
        '$store.state.last_online_answer': function(answer){
            if(!answer || !this.questions.some((q) => q.id == answer.question_id))
                return;

            const entry = {
                question: answer.question_id,
                choice: answer.choice,
                timestamp: answer.timestamp,
                correct: answer.correct,
                score: answer.score
            };
            const idx = this.own_answers.findIndex((a) => a.question == answer.question_id);
            if(idx >= 0)
                this.own_answers.splice(idx, 1, entry);
            else
                this.own_answers.push(entry);

            this.sync_question();
        }
    },
    async created(){
        try{
            const result = await api.stage_questions(this.stage_id);
            this.stage = result.stage;
            this.theme = result.theme || null;
            this.questions = result.questions;
            this.own_answers = result.own_answers || [];
            // Child components (Quiz.vue, etc.) mount and run their own
            // initial render BEFORE this component's mounted() hook fires,
            // and they read $store.state.game.question directly - syncing
            // here, right after the fetch resolves and before the next
            // render, guarantees it's populated before any child ever mounts.
            this.sync_question();
        }catch(ex){
            window.toast.error(ex.message || "No se han podido cargar las preguntas.");
        }finally{
            this.loading = false;
        }
    },
    mounted(){
        $('.modal-backdrop').remove();
    },
    methods: {
        // The type/*.vue components (Quiz, TrueFalse, ...) read the
        // globally-shared game.question/current_question/user/clients - they
        // were built for the synchronized in-person mode where the server
        // pushes those over the websocket. Here the player advances at their
        // own pace within one route, with identity/data coming from the REST
        // API instead, so this view has to locally fake that same shape.
        sync_question(){
            if(!this.current_wrapper) return;
            this.$store.commit("setQuestion", { question: this.current_wrapper.question });
            this.$store.commit("setCurrentQuestion", this.current_wrapper.question.id);

            const online_user = this.$store.state.online_user;
            if(!online_user) return;

            this.$store.commit("setUser", {
                id: online_user.id,
                username: online_user.username,
                role: utils.USER_ROLES.PLAYER,
                avatar: online_user.avatar,
                avatar_style: online_user.avatar_style,
            });
            // Single-entry "clients" list standing in for the websocket
            // broadcast the type components normally read - own_answers is a
            // superset of the {question, choice} shape they look for, the
            // extra correct/score fields are simply ignored by them.
            this.$store.commit("setClients", [
                { id: online_user.id, username: online_user.username, data: this.own_answers }
            ]);
        },
        next_question(){
            if(this.is_last){
                this.finished = true;
                return;
            }
            this.current_index++;
        },
        go_back(){
            if(this.stage)
                this.$router.push({name: "MyStages", params: {season_id: this.stage.season_id}});
            else
                this.$router.push({name: "MySeasons"});
        },
        format_title(title){
            const regex = /https?:\/\/[^\s]+/g;
            return title.replace(regex, (match) => {
                this.preview_img = match;
                return `<button type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#previewImageModal">ver imagen</button>`;
            });
        },
        logout(){
            utils.reset_online_client();
        }
    }
}
</script>

<style scoped>
    .stage-activity{
        background-color: var(--vc-paper-200);
    }

    .stage-activity-topbar{
        background-color: var(--vc-ink-900);
        color: var(--vc-paper-50);
        flex-shrink: 0;
    }


    .stage-activity-name{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 1rem;
    }

    .stage-activity-segment{
        font-family: "Archivo", sans-serif;
        font-weight: 700;
        font-size: 0.7rem;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: var(--vc-accent-500);
    }

    .stage-activity-user{
        font-size: 0.85rem;
        color: rgba(255, 255, 255, 0.7);
    }

    .icon-btn{
        width: 32px;
        height: 32px;
        flex-shrink: 0;
        border-radius: 6px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background-color: transparent;
        color: var(--vc-paper-50);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .icon-btn:hover{
        background-color: rgba(255, 255, 255, 0.1);
    }

    .stage-activity-empty{
        color: var(--vc-text-600);
        text-align: center;
        padding: 40px 0;
    }

    .stage-complete-icon{
        font-size: 3rem;
        color: var(--vc-accent-500);
    }

    .stage-complete-headline{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 1.4rem;
        margin-top: 12px;
    }

    .stage-complete-detail{
        color: var(--vc-text-600);
        margin-top: 4px;
    }

    .feedback-banner{
        text-align: center;
        padding: 28px;
        border-radius: 12px;
    }

    .feedback-icon{
        font-size: 3rem;
    }

    .feedback-headline{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 1.6rem;
        text-transform: uppercase;
        margin-top: 8px;
    }

    .feedback-detail{
        color: var(--vc-text-600);
        margin-top: 4px;
    }

    .feedback-points{
        font-family: "Archivo", sans-serif;
        font-weight: 900;
        font-size: 2.2rem;
        margin-top: 12px;
    }
    .feedback-points small{
        font-family: "Public Sans", sans-serif;
        font-weight: 700;
        font-size: 0.9rem;
        text-transform: uppercase;
    }

    .feedback-correct{
        background-color: var(--vc-success-100);
    }
    .feedback-correct .feedback-icon,
    .feedback-correct .feedback-headline,
    .feedback-correct .feedback-points{
        color: var(--vc-success-500);
    }

    .feedback-incorrect{
        background-color: var(--vc-danger-100);
    }
    .feedback-incorrect .feedback-icon,
    .feedback-incorrect .feedback-headline{
        color: var(--vc-danger-500);
    }
</style>
